import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import communicationImg from '../../../../assets/images/communication-img.png'

const Communication = () => {
    const navigate = useNavigate();
    return (
        <section className="get-started pt-0">
            <div className="appContainer">
                <Row className='align-items-center'>
                    <Col xs={12} lg={6} className='my-3'>
                        <h2>We are dynamic lover communication</h2>
                        <p className='grey-text fs-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan</p>
                        <Row>
                            <Col xs={12} lg={4} className='mt-3'>
                                <h2 className='mb-0'>24</h2>
                                <p className='mb-0 text-capitalize grey-text'>Year of <br /> experience</p>
                            </Col>
                            <Col xs={12} lg={4} className='mt-3'>
                                <h2 className='mb-0'>10.4m</h2>
                                <p className='mb-0 text-capitalize grey-text'>Active <br /> users</p>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} lg={6} className='my-3'>
                        <img src={communicationImg} alt="communication" className='img-fluid' />
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default Communication
